// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"8b2cd5df","229":"bf4035c0","365":"96ee4a5a","447":"d9c1d8c7","511":"5831eebf","678":"a76b6607","694":"33f0ce3c","704":"622134cb","787":"505ff7a2","856":"3b72c7c3"}[chunkId] + ".chunk.js";
};